'use client';

import { FC, useEffect } from 'react';
import { TTransfersNextStepStateWithActions } from '../../../../utils/useTransfersNextStepState.client';
import { TransfersCommonStepsIds } from '../../../../types';

const RedirectToNetworkSelection: FC<{
  state: TTransfersNextStepStateWithActions;
}> = ({ state }) => {
  useEffect(() => {
    state.changeToPageAndBindActions({
      pageId: TransfersCommonStepsIds.ChooseNetwork,
      newBackAction: {
        pageId: TransfersCommonStepsIds.AssetAndNetworkSummary,
        type: 'page',
      },
    });
  }, [state]);

  return null;
};

export { RedirectToNetworkSelection };
